var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-5"},_vm._l((_vm.notificationOptions),function(notificationOption,index){return _c('v-row',{key:'notificationOption' + index,attrs:{"justify":"center"}},[_c('v-btn',{on:{"click":function($event){return _vm.subscribeToNotification(notificationOption.option)}}},[_vm._v(_vm._s(notificationOption.title))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }